import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { UserService } from '../../../providers/user.service';
import { BaseComponent } from '../../shared/base/base.component';

@Component({
  selector: 'app-item-chooser',
  templateUrl: './item-chooser.component.html',
  styleUrls: ['./item-chooser.component.scss']
})
export class ItemChooserComponent extends BaseComponent implements OnInit {

  @Input() service_type: string;
  @Input() vendor: string;
  @Input() person_type: string;
  @Output() choosed = new EventEmitter();
  items: any = [];

  constructor(
    public userService: UserService,
    public translator: TranslateService,
    public cookieItem: CookieService,
    public titleService: Title,
  ) {
    super(userService, translator, cookieItem, titleService);
  }

  async ngOnInit() {
    this.userService.getItemsByServiceType(this.service_type).subscribe((result: any) => {
      this.items = result;
    }, error => {
      console.error(error);
    });
  }

  priceChoosed(price) {
    this.choosed.emit(price);
  }

}
